import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select, InputNumber, Switch, Row, Col, Card } from 'antd';
import { ImageUploadField } from '../../components/ImageUploadField';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'name', label: 'Name', placeholder: 'Restaurant name', required: true },
  { key: 'description', label: 'Description', placeholder: 'Restaurant description', textarea: true, rows: 2 },
];

export const RestaurantCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'restaurants' });

  return (
    <Create resource="restaurants" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS),
          })
        }
      >
        <Card title="Images" size="small" style={{ marginBottom: 24 }}>
          <Row gutter={24}>
            <Col>
              <Form.Item label="Logo" name="logoUrl">
                <ImageUploadField subPath="restaurant" previewWidth={120} previewHeight={120} />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Cover Image" name="coverImageUrl">
                <ImageUploadField subPath="restaurant" previewWidth={240} previewHeight={120} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card title="Basic Info" size="small" style={{ marginBottom: 24 }}>
          <LocalizedContentTabs fields={LANG_FIELDS} showSharedDivider={false} />
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item label="Cuisine Type" name="cuisineType">
                <Input placeholder="e.g. Chinese, Japanese" />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Tags" name="tags">
                <Select mode="tags" placeholder="e.g. halal, vegan, fine-dining" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card title="Contact & Location" size="small" style={{ marginBottom: 24 }}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Address" name="address">
                <Input placeholder="Restaurant address" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Phone" name="phone">
                <Input placeholder="+852 ..." />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Website" name="websiteUrl">
                <Input placeholder="https://..." />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Latitude" name="latitude">
                <InputNumber style={{ width: '100%' }} min={-90} max={90} step={0.0001} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Longitude" name="longitude">
                <InputNumber style={{ width: '100%' }} min={-180} max={180} step={0.0001} />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Sort Order" name="sortOrder" initialValue={0}>
              <InputNumber style={{ width: '100%' }} min={0} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
              <Switch />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
